'use strict';

exports.__esModule = true;
var BLACK = 'rgb(26,23,27)';
exports.BLACK = BLACK;
var BLACK_TRANSPARENT = 'rgba(26,23,27,0.25)';
exports.BLACK_TRANSPARENT = BLACK_TRANSPARENT;
var BLUE = 'rgb(0,51,98)';
exports.BLUE = BLUE;
var BLUE_TRANSPARENT = 'rgba(0,51,98,0.75)';
exports.BLUE_TRANSPARENT = BLUE_TRANSPARENT;
// la-dolfina
var DARK_BLUE = 'rgb(44,70,119)';
exports.DARK_BLUE = DARK_BLUE;
// la-aguada
var CLARET = 'rgb(137,28,30)';
exports.CLARET = CLARET;
// ellerstina
var DARK_GREY = 'rgb(75,75,77)';
exports.DARK_GREY = DARK_GREY;
// las-monjitas
var ORANGE = 'rgb(236,134,19)';
exports.ORANGE = ORANGE;
// alegria
var PURPLE = 'rgb(166,54,132)';
exports.PURPLE = PURPLE;
// chapaleufu
var RED = 'rgb(219,66,70)';
exports.RED = RED;
var WHITE = 'white';
exports.WHITE = WHITE;
var WHITE_TRANSPARENT = 'rgba(255,255,255,0.35)';
exports.WHITE_TRANSPARENT = WHITE_TRANSPARENT;
var WHITE_TRANSPARENT_50 = 'rgba(255,255,255,0.50)';
exports.WHITE_TRANSPARENT_50 = WHITE_TRANSPARENT_50;
var WHITE_TRANSPARENT_65 = 'rgba(255,255,255,0.65)';
exports.WHITE_TRANSPARENT_65 = WHITE_TRANSPARENT_65;
var WHITE_TRANSPARENT_85 = 'rgba(255,255,255,0.85)';

exports.WHITE_TRANSPARENT_85 = WHITE_TRANSPARENT_85;
var FONT = '"Oswald", sans-serif';
exports.FONT = FONT;
var FONT_LIGHT = 300;
exports.FONT_LIGHT = FONT_LIGHT;